// 2) Third-party libraries
import createSagaMiddleware from "@redux-saga/core";
import { createBrowserHistory } from "history";
import { createReduxHistoryContext } from "redux-first-history";
import { configureStore, Middleware } from "@reduxjs/toolkit";
import { includes } from "lodash-es";

// 3) Local imports
// 3.3 Project-specific modules — components/types
import { createRootReducer, rootSaga } from ".";

// Re-export RootState from storeTypes for backward compatibility
export type { RootState } from './storeTypes';

// Store instance registry
import { registerStore } from './storeInstance';

// 3.5 Redux actions / store
import { resetReduxStateAction } from "./auth/authSlice";

// Create a history object
const { 
	createReduxHistory, 
	routerMiddleware, 
	routerReducer
} = createReduxHistoryContext({
	history: createBrowserHistory(),
});

const sagaMiddleware = createSagaMiddleware();
const combinedReducers = createRootReducer(routerReducer);
const rootReducer = (state: any, action: any) => {
	if (action.type === resetReduxStateAction.type) {
		state = undefined;
	}

	return combinedReducers(state, action);
};
const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) => 
		getDefaultMiddleware({
			// Disable thunk since you're using saga
			thunk: false,
			// Disable serializable check for history and other non-serializable data
			serializableCheck: false,
		})
		.concat(
			routerMiddleware as Middleware,
			sagaMiddleware as Middleware
		)
});

// Register store instance for lazy access (breaks circular dependencies)
registerStore(store);

const rootSagaTask = sagaMiddleware.run(rootSaga);
rootSagaTask.toPromise().catch((err: any) => {
	if (includes(err.message, 'Generator is already running')) {
		window.location.reload();

		return;
	}
});


export type AppDispatch = typeof store.dispatch;

// Create the history object
export const history = createReduxHistory(store);
export default store;
